import React, { useState, useEffect } from "react";
import { Result, Button, Typography, Spin } from "antd";
import { Link } from "react-router-dom";
import "./index.css";
import { deliveryBookingEmailConfirmApiV2 } from "../../../../../src/api/api"

const DeliveryBookingEmailConfirm = (props) => {
  const query_params = new URLSearchParams(props.location.search);
  const [requestId, setRequestId] = useState(query_params.get("requestId"));
  const [identity, setIdentity] = useState(query_params.get("identity"));
  const [status, setStatus] = useState(null);
  const [requestorType, setRequestorType] = useState("");
  const [isShowProcessing, setIsShowProcessing] = useState(true);
  const { Paragraph, Text } = Typography;

  useEffect(()=> {
    deliveryBookingEmailConfirmApiMethod().then();
  },[])

  const deliveryBookingEmailConfirmApiMethod = async e => {
    let reqBody = {
      requestId: requestId,
      identity: identity
    };

    let setConfirmLoading = true
    let confirmLoadingTime = 20
    const timer = setInterval(() => {
      confirmLoadingTime -= 1;
    }, 1000);

    setTimeout(() => {
      clearInterval(timer);
      setIsShowProcessing(false);
      if (setConfirmLoading) {
        setStatus("error");
      }
    }, confirmLoadingTime * 1000);

    deliveryBookingEmailConfirmApiV2(reqBody).then(respBody => {
      if (respBody.status != null) {
        setConfirmLoading = false
      }
      if (respBody.status === "success") {
        setStatus("success");
        setRequestorType(respBody.requestorType);
      } else if (respBody.status === "fail") {
        if (respBody.errCode === "ERR_SUBMITTED") {
          setStatus("ERR_SUBMITTED");
        } else if (respBody.errCode === "ERR_EMAIL_EXPIRY") {
          setStatus("ERR_EMAIL_EXPIRY");
        }
      }
      setIsShowProcessing(false);
    })
  };
  
  
  return (
    <div>
      <Spin
        style={{ fontSize: 40 }}
        size="large"
        tip="Processing..."
        spinning={isShowProcessing}
        className="loadingStyle"
      >
      {status === "error" || status === "ERR_NULL_REQUEST" ? <Result
        status="error"
        title="Confirmation error!"
        extra={[
          <div>
            <Paragraph>
              <div className="cssBox">
                <Text strong style={{ fontSize: 18 }}>
                  Something went wrong. Please try again.
                      </Text>
              </div>
            </Paragraph>
          </div>,
          <div>
            <Link to="/">
              <Button icon="close" type="primary" key="console">
                Close
              </Button>
            </Link>
          </div>
        ]}
      /> : null}

      {status === "success" ? <Result
        status="success"
        title="Confirmation is submitted!"
        extra={[
          <div>
            <Paragraph>
              <div className="cssBox">
                <Text strong style={{ fontSize: 18 }}>
                  Your confirmation is submitted successfully.
                        <br /><br />
                        Thank you,
                        <br />
                        OOCL Customer Services.
                      </Text>
              </div>
            </Paragraph>
          </div>,
          <div>
            <Link to="/">
              <Button icon="close" type="primary" key="console">
                Close
              </Button>
            </Link>
          </div>
        ]}
      /> : null}

      {status === "ERR_SUBMITTED" ? <Result
        title="Confirmation has been submitted!"
        extra={[
          <div>
            <Paragraph>
              <div className="cssBox">
                <Text strong style={{ fontSize: 18 }}>
                  Your confirmation has been submitted before.
                        <br /><br />
                        Thank you,
                        <br />
                        OOCL Customer Services.
                      </Text>
              </div>
            </Paragraph>
          </div>,
          <div>
            <Link to="/">
              <Button icon="close" type="primary" key="console">
                Close
              </Button>
            </Link>
          </div>
        ]}
      /> : null}
      {status === "ERR_EMAIL_EXPIRY" ? <Result
        status="warning"
        title="Confirmation is expired!"
        extra={[
          <div>
            <Paragraph>
              <div className="cssBox">
                <Text strong style={{ fontSize: 18 }}>
                  Your confirmation is expired.<br />
                  {requestorType === 'Door Delivery Booking' ? "Please submit your release to order request again by the Consignee." : "Please submit your request again."}
                  <br /><br />
                        Thank you,
                        <br />
                        OOCL Customer Services.
                      </Text>
              </div>
            </Paragraph>
          </div>,
          <div>
            <Link to="/">
              <Button icon="close" type="primary" key="console">
                Close
              </Button>
            </Link>
          </div>
        ]}
      /> : null}
      </Spin>
    </div>
  );
}

export default DeliveryBookingEmailConfirm
